
import formatThousands from './formatThousands'

export default (currentPrice, price) => {
  let delta = 0

  if (price - currentPrice === 0) {
    delta = '+0'
  } else if (price > currentPrice) {
    delta = `+${formatThousands(price - currentPrice)}`
  } else {
    delta = `${formatThousands(price - currentPrice)}`
  }

  return delta
}
